import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Nav } from "./components/Nav";
import Home from "./pages/Home";
import CaseStudy from "./pages/CaseStudy";
import { useLenis } from "./lib/smooth";
import { LightboxProvider } from "./components/Lightbox";

function App() {
  useLenis();
  return (
    <div className="App grain">
      <LightboxProvider>
      <BrowserRouter>
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work/:slug" element={<CaseStudy />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Toaster position="bottom-center" />
      </BrowserRouter>
      </LightboxProvider>
    </div>
  );
}

export default App;
